// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../assets/img/white-check.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".payment-process-section[data-v-5a587bc5] .input-group.checked .option-input + label span {\n  background-color: #2DB782 !important;\n}\n.payment-process-section[data-v-5a587bc5] .input-group .option-input:checked + label span .ic-check {\n  background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n  background-size: 70%;\n  background-repeat: no-repeat;\n  background-position: center;\n}", ""]);
// Exports
module.exports = exports;
